import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Link from 'gatsby-link'
import styles from './styles'

const linkGenerator = (type, uid, service) => {
  switch (type) {
    case 'ct-shot':
      return `/shot/${uid}`
    case 'ct-method':
      return `/method/${uid}`
    case 'ct-study':
      return `/study/${uid}`
    case 'ct-blog':
      return `/blog/${uid}`
    case 'ct-service-focus':
      return `/service/${service}/${uid}`
  }
}

const labelMapper = {
  'ct-shot': 'Shot',
  'ct-method': 'Method',
  'ct-study': 'Case Study',
  'ct-blog': 'Blog Post',
  'ct-service-focus': 'Service Focus'
}

/**
 * Single Content Link
 */
const ContentLink = ({ contentLink, service, classes }) => {
  const { image, title } = contentLink.document[0].data
  const { type, uid = 'test' } = contentLink.document[0]

  const contentStyle = image && image.localFile ? {backgroundImage: `url(${image.localFile.childImageSharp.original.src})`} : null

  return (
    <div className={classes.contentLink}>
      <div className={classes.contentMeta}>
        <Link to={linkGenerator(type, uid, service)}><Typography className={classes.contentMetaTitle}>{ title.text }</Typography></Link>
        <Typography className={classes.contentMetaType}>{ labelMapper[type] }</Typography>
      </div>
      <Link to={linkGenerator(type, uid, service)}>
        <div
          className={classes.contentImage}
          style={contentStyle}
        />
      </Link>
    </div>
  )
}

/**
 * Main Component
 */
const RelatedContent = withStyles(styles)(props => {
  const { classes, content, noBackground, service } = props

  return (
    <div className={classes.contents}>
      <div className={classes.section} style={{backgroundColor: noBackground ? 'transparent' : '#fff'}}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div className={classes.contentWrap}>
              {
                content.items &&
                content.items.map((item, i) => {
                return i < 2 ? (
                  <ContentLink
                    key={i}
                    contentLink={item.content_link}
                    classes={classes}
                    service={service}
                  />
                ) : null
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

export default withStyles(styles)(RelatedContent)



// WEBPACK FOOTER //
// ./src/components/relatedcontent/index.js